import {
  Card,
  DateFormats,
  formatISODate,
  Inline,
  Separator,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import type { ContractorInvoice } from '@omnipresentgroup/types';
import type { ReactElement } from 'react';

import {
  ContractorInvoiceStatus,
  type StatusOverride,
} from '../../contractor-invoice-status';

const InvoiceStatusItem = ({
  id,
  label,
  value,
}: {
  id: string;
  label: string;
  value: string | ReactElement;
}) => {
  return (
    <Stack gap="8" w="stretch">
      <Typography as="label" size="12" weight="medium" color="subtle" id={id}>
        {label}
      </Typography>
      {typeof value === 'string' ? (
        <Typography as="span" size="16" weight="medium" aria-labelledby={id}>
          {value}
        </Typography>
      ) : (
        value
      )}
    </Stack>
  );
};

export const ContractorInvoiceStatusDetails = ({
  invoice,
  statusOverride,
}: {
  invoice: ContractorInvoice;
  statusOverride?: StatusOverride;
}) => {
  return (
    <Card p="24">
      <Stack gap="24">
        <Inline gap="24">
          <InvoiceStatusItem
            id="invoice-raised"
            label="Raised"
            value={
              invoice?.raisedAt
                ? formatISODate(invoice.raisedAt, DateFormats.Date)
                : '-'
            }
          />
          <Separator />
          <InvoiceStatusItem
            id="invoice-due"
            label="Due"
            value={
              invoice?.dueDate
                ? formatISODate(invoice.dueDate, DateFormats.Date)
                : '-'
            }
          />
        </Inline>
        <Inline gap="24">
          <InvoiceStatusItem
            id="invoice-paid"
            label="Paid"
            value={
              invoice?.paidAt
                ? formatISODate(invoice.paidAt, DateFormats.Date)
                : '-'
            }
          />
          <Separator />
          <InvoiceStatusItem
            id="invoice-status"
            label="Status"
            value={
              <ContractorInvoiceStatus
                invoice={invoice}
                statusOverride={statusOverride}
              />
            }
          />
        </Inline>
      </Stack>
    </Card>
  );
};
